import {AnalyticsScalarMetric} from '../../models/api/analyticsMetricsModel';
import {ScalarToProgressTransformer} from './analyticsMetricsTransformers';
import {
  AnalyticsComputedMetricTypesEnum,
  AnalyticsComputedProgressMetricBase,
  AnalyticsComputedProgressMetricsEnum,
} from './analyticsMetricsTransformersTypes';
import {makeDefaultProgressBarSeries} from './common';

/*
 * Transformer.
 */

export const pctMessagesWithMessageTemplatesToProgress: ScalarToProgressTransformer = (
  metricData: AnalyticsScalarMetric | undefined,
): AnalyticsComputedProgressMetricBase => {
  const transformedMetricBase = {
    id: AnalyticsComputedProgressMetricsEnum.MESSAGE_TEMPLATE_REPORT_PROGRESS,
    metricType: AnalyticsComputedMetricTypesEnum.CUSTOM_PROGRESS,
    isEmpty: metricData?.isEmpty ?? false,
  };

  if (!metricData) {
    return {
      ...transformedMetricBase,
      series: [],
    };
  }

  return {
    ...transformedMetricBase,
    series: makeDefaultProgressBarSeries(metricData.value),
  };
};
